<template>
  <ubi-panel style="margin-left: 15px;">
    <el-row style="
    border-bottom: 1px solid #0ab1bf;">
      <el-col :lg="2" style="padding-top: 4px">
        <slot name="checkboxUseNetwork"></slot>
      </el-col>
      <el-col :lg="8">
        <h2>
          <slot name="iconAndTitleNetwork"></slot>
        </h2>
      </el-col>
      <el-col :lg="14"  style="padding-top: 6px;text-align: right">
        <slot name="customize"></slot>
        <div style="font-size: 11px;text-align:right"><slot name="alreadyPublished"></slot></div>
      </el-col>
    </el-row>
    <slot name="content">
    </slot>
    <slot name="diffusionDisabled">
    </slot>
  </ubi-panel>
</template>

<script>
  export default {
    name: 'BlockEditoCreateSocialNetwork'
  }
</script>

<style>

</style>
